import { FullFormAction } from "../../../../../Engine/Core/Store/FullFormAction";

import { CustomErrorLogTooltipState } from "./CustomErrorLogTooltipState";
import { CustomErrorLogTooltipActionType } from "./CustomErrorLogTooltipAction";

export function customErrorLogTooltipReducer(
    state: undefined | CustomErrorLogTooltipState,
    action: FullFormAction
): undefined | CustomErrorLogTooltipState {
    if (action.type === CustomErrorLogTooltipActionType.Close) {
        return undefined;
    }
    if (action.type === CustomErrorLogTooltipActionType.Open) {
        return {
            anchorElement: action.payload.anchorElement,
            message: action.payload.message,
        };
    }
    return state;
}
